import { AppProvider } from "./providers/app-provider"
import { Router } from "./router"

export function App() {
  return (
    <AppProvider>
      <Router />
    </AppProvider>
  )
}
